import SidebarQueues from './SidebarQueues'

export default SidebarQueues
